import React from 'react'

const AddTranslationsButton = props => {
    return (
        <div className={`add-translations-container ${props.languages.size === 0 ? 'disabled' : ''}`}
            onClick={props.languages.size !== 0 ? () => props.toggleTranslationsModal(props.editedConferenceLink, props.editedMeetingInformation, props.editedTopicName) : ''}>
            <div className="add-translations">
                <div className="side-icon">
                    <i className="im-plus-circle-closed" />
                </div>
                <div className="add-translations-title">
                    {props.t('add.translations')}
                </div>
            </div>
        </div>
    )
}


export default AddTranslationsButton
